import { render, staticRenderFns } from "./GoingViralSpotlightModule.vue?vue&type=template&id=18a48798"
import script from "./GoingViralSpotlightModule.vue?vue&type=script&setup=true&lang=ts"
export * from "./GoingViralSpotlightModule.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports